module.exports = __webpack_public_path__ + "assets/img/left.0aa325db.svg";